import * as z from "zod";

export const unmergeFulfillmentGroups = {
  name: "unmergeFulfillmentGroups" as const,
  input: z.object({ fulfillmentGroupIds: z.array(z.string()) }),
  output: z.object({}),
};
